<template>
  <div class="video-preview">
    <video v-if="value" ref="videoEl" :src="value" class="video-preview__video" controls muted playsinline></video>
    <div v-else class="video-preview__empty">No video URL</div>
    <v-btn small text color="primary" class="mt-2" :disabled="!value" @click="handleReload">
      <v-icon size="16" class="mr-1">mdi-reload</v-icon>
      Reload video
    </v-btn>
  </div>
</template>

<script>
// Component preview video dùng chung cho các editor section (vd: chọn media video/ảnh).
// Trình duyệt không tự load lại <video> khi :src đổi trong 1 số trường hợp cache/CDN,
// nên có nút Reload để chủ động gọi videoEl.load().
export default {
  name: 'VideoPreview',
  props: {
    value: {
      type: String,
      default: '',
    },
  },
  methods: {
    handleReload() {
      const videoEl = this.$refs.videoEl;
      if (!videoEl) return;
      videoEl.load();
    },
  },
};
</script>

<style scoped>
.video-preview__video {
  width: 100%;
  max-height: 260px;
  border-radius: 8px;
  background-color: #000;
  display: block;
}
.video-preview__empty {
  width: 100%;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px dashed #0000001f;
  border-radius: 8px;
  color: #00000061;
  font-size: 13px;
}
</style>
